import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import JaliscoReach from "./JaliscoReach";
import "./servicarnes.css";

const WHATSAPP = "https://wa.me/52XXXXXXXXXX?text=Hola%2C%20quiero%20cotizar%20producto";
const CITIES = "Guadalajara · Puerto Vallarta · Tepic · Colima · Lázaro Cárdenas · Morelia · Aguascalientes · San Luis Potosí";

const FAMILIES = [
  { idx: "01", name: "Res", desc: "Clod, menudo, labios y cortes de línea.", icon: "beef", image: "/servicarnes/familia-res.jpg" },
  { idx: "02", name: "Cerdo", desc: "Pierna, lengua, espalda. Deshuese propio de pierna.", icon: "pork", image: "/servicarnes/familia-cerdo.jpg" },
  { idx: "03", name: "Ave", desc: "Pechuga, alitas, piernas y muslos.", icon: "bird", image: "/servicarnes/familia-ave.jpg" },
  { idx: "04", name: "Snacks y Valor Agr.", desc: "Boneless, nuggets y empanizados.", icon: "snack", image: "/servicarnes/familia-snacks.jpg" },
  { idx: "05", name: "Papas", desc: "Gruesa, delgada y gajo.", icon: "potato", image: "/servicarnes/familia-papas.jpg" },
];

function familyListUrl(name) {
  return `https://wa.me/52XXXXXXXXXX?text=${encodeURIComponent(`Hola, quiero el listado de productos de ${name}`)}`;
}

const STEPS = [
  { idx: "01", title: "Ordena", body: "Pasamos a tu zona levanta el pedido en el acto." },
  { idx: "02", title: "Prepara", body: "Sale de nuestras cámaras de refrigeración garantizando la máxima frescura." },
  { idx: "03", title: "Entrega", body: "La misma persona te entrega en puerta y liquida la cuenta. Cero complicaciones." },
];

const BRANCHES = [
  ["Guadalajara", "Matriz"],
  ["Puerto Vallarta"],
  ["Tepic"],
  ["Colima"],
  ["Lázaro Cárdenas"],
  ["Morelia"],
  ["Aguascalientes"],
  ["San Luis Potosí"],
];

const LOCATIONS = [
  {
    id: "gdl-matriz",
    name: "Matriz Guadalajara",
    address: "Calle 30 #2585 Int. 1, Zona Industrial, Guadalajara, Jal.",
    phone: "33 13 81 34 95",
    tel: "3313813495",
    query: "Calle 30 2585 Int 1 Zona Industrial, Guadalajara, Jalisco, Mexico",
    zoom: 16,
  },
  {
    id: "gdl-sucursal",
    name: "Sucursal Guadalajara",
    address: "Calle 7 #615, Zona Industrial, Guadalajara, Jal.",
    phone: "33 13 81 34 95",
    tel: "3313813495",
    query: "Calle 7 615 Zona Industrial, Guadalajara, Jalisco, Mexico",
    zoom: 16,
  },
  {
    id: "colima",
    name: "Colima",
    address: "José Antonio Torres #368, Col. Centro, Colima, Col.",
    phone: "31 2312 2122",
    tel: "3123122122",
    query: "Jose Antonio Torres 368 Colonia Centro, Colima, Colima, Mexico",
    zoom: 16,
  },
  {
    id: "vallarta",
    name: "Puerto Vallarta",
    address: "Av. México #2000, Col. Ixtapa, Puerto Vallarta, Jal.",
    phone: "32 2223 7401",
    tel: "3222237401",
    query: "Avenida Mexico 2000 Colonia Ixtapa, Puerto Vallarta, Jalisco, Mexico",
    zoom: 16,
  },
  {
    id: "lazaro",
    name: "Lázaro Cárdenas",
    address: "Volcán Seboruco M-7 L-17, Col. Isla del Cayacal, Lázaro Cárdenas, Mich.",
    phone: "75 3532 2320",
    tel: "7535322320",
    query: "Volcan Seboruco M-7 L-17 Colonia Isla del Cayacal, Lazaro Cardenas, Michoacan, Mexico",
    zoom: 16,
  },
  {
    id: "ags",
    name: "Aguascalientes",
    address: "Bloque B 14 y 15, CC Central de Abastos, Aguascalientes, Ags.",
    phone: "44 9971 2196",
    tel: "4499712196",
    query: "Central de Abastos Bloque B 14 y 15, Aguascalientes, Aguascalientes, Mexico",
    zoom: 16,
  },
  {
    id: "morelia",
    name: "Morelia",
    address: "Oriente Cuatro #551, Col. Cd. Industrial, Morelia, Mich.",
    phone: "44 3222 6008",
    tel: "4432226008",
    query: "Oriente Cuatro 551 Colonia Ciudad Industrial, Morelia, Michoacan, Mexico",
    zoom: 16,
  },
  {
    id: "tepic",
    name: "Tepic",
    address: "Chemibu Bodega Z-24 y C-25, Col. Nayarabastos, Tepic, Nay.",
    phone: "31 1211 6626",
    tel: "3112116626",
    query: "Chemibu Bodega Z-24 C-25 Colonia Nayarabastos, Tepic, Nayarit, Mexico",
    zoom: 16,
  },
  {
    id: "slp",
    name: "San Luis Potosí",
    address: "",
    phone: "44 9971 2196",
    tel: "4499712196",
    query: "San Luis Potosi, Mexico",
    zoom: 12,
  },
];

function mapEmbed(place) {
  const params = new URLSearchParams({
    q: place.query,
    hl: "es",
    z: String(place.zoom),
    output: "embed",
  });
  return `https://maps.google.com/maps?${params.toString()}`;
}

function mapSearch(place) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place.query)}`;
}

const ROW_MAYOREO = [
  "Empacadoras y procesadoras",
  "Comedores industriales",
  "Cadenas de autoservicio / supermercados",
  "Distribuidoras y subdistribuidores",
];

const ROW_MENUDEO = [
  "Carnicerías y cremerías",
  "Restaurantes y hoteles",
  "Taquerías y banquetes",
  "Fondas y cocinas económicas",
];

function useReveal(threshold = 0.2) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, visible };
}

const FAMILY_ICONS = {
  beef: "/servicarnes/icons/res.png",
  pork: "/servicarnes/icons/cerdo.png",
  bird: "/servicarnes/icons/ave.png",
  snack: "/servicarnes/icons/snacks.png",
  potato: "/servicarnes/icons/papas.png",
};

function FamilyIcon({ type }) {
  return <span className="sc-family-icon" style={{ "--icon": `url(${FAMILY_ICONS[type]})` }} aria-hidden="true" />;
}

function Marquee({ className = "sc-marquee", textClass = "sc-mono" }) {
  const line = `${CITIES} · `;
  return (
    <div className={className}>
      <div className="sc-marquee-track">
        <span className={textClass}>{line.repeat(2)}</span>
        <span className={textClass}>{line.repeat(2)}</span>
      </div>
    </div>
  );
}

const STATS = [
  ["Catálogo\nextenso", "Variedad y disponibilidad constante en todas las líneas."],
  ["Gran\nalmacenaje", "Infraestructura y capacidad de conservación en frío a gran escala."],
  ["Red de\ndistribución", "Cobertura logística con rutas de reparto eficientes"],
  ["Mismo\ndía", "Entregas ágiles adaptadas al ritmo de tu negocio."],
];

function StatBar() {
  return (
    <section className="sc-stats">
      <div className="sc-stats-grid">
        {STATS.map(([title, detail]) => (
          <div className="sc-stat" key={title}>
            <strong>
              {title.split("\n").map((line) => (
                <span key={line}>{line}</span>
              ))}
            </strong>
            <em>{detail}</em>
          </div>
        ))}
      </div>
    </section>
  );
}

function PhotoTile({ src, alt, shade, children, position = "center center" }) {
  return (
    <div className="sc-tile">
      <img src={src} alt={alt} style={{ objectPosition: position }} />
      <div className="sc-tile-shade" style={{ background: shade }} />
      {children}
    </div>
  );
}

function ServicarnesPage() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  const [place, setPlace] = useState(LOCATIONS[0]);
  const values = useReveal(0.35);
  const coverage = useReveal(0.15);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <div className="sc-root">
      <Helmet>
        <title>Grupo Servicarnes | Vista previa</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link href="https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;800&family=IBM+Plex+Mono:wght@400;500&family=Inter:wght@400;500&display=swap" rel="stylesheet" />
      </Helmet>

      <header className={`sc-header${solid ? " is-solid" : ""}${open ? " is-open" : ""}`}>
        <a className="sc-wordmark" href="#inicio" onClick={closeMenu}>Servicarnes</a>
        <nav className="sc-nav" aria-label="Secciones">
          <a href="#productos" onClick={closeMenu}>Productos</a>
          <a href="#cobertura" onClick={closeMenu}>Cobertura</a>
          <a href="#servicio" onClick={closeMenu}>Servicio</a>
          <a href="#nosotros" onClick={closeMenu}>Nosotros</a>
        </nav>
        <a className="sc-btn" href={WHATSAPP} target="_blank" rel="noopener noreferrer">Pedir por WhatsApp →</a>
        <button className="sc-menu-btn" type="button" onClick={() => setOpen((value) => !value)}>
          {open ? "Cerrar" : "Menú"}
        </button>
      </header>

      <section className="sc-hero" id="inicio">
        <div className="sc-hero-media">
          <img src="/servicarnes/hero.jpg" alt="" />
          <div className="sc-hero-shade" />
        </div>
        <div className="sc-hero-grid">
          <div>
            <p className="sc-mono sc-kicker">Desde 1994 · Guadalajara + 7 Sucursales</p>
            <h1 className="sc-headline">Nunca te quedes<br />sin producto.</h1>
            <p className="sc-lead">
              Distribuimos proteína y alimentos congelados a carnicerías, taquerías, cremerías y distribuidores en todo el Occidente. 200 claves en inventario y entrega el mismo día.
            </p>
            <div className="sc-hero-actions">
              <a className="sc-btn" href={WHATSAPP} target="_blank" rel="noopener noreferrer">Pedir por WhatsApp →</a>
              <a className="sc-ghost on-dark" href="#productos">Ver las 5 familias ↓</a>
            </div>
            <p className="sc-mono sc-cold">Cámaras a −18 °C · Entrega el mismo día</p>
          </div>
          <img className="sc-hero-logo" src="/servicarnes/logo.png" alt="Grupo Servicarnes — Servicio y Variedad" />
        </div>
        <Marquee />
      </section>

      <StatBar />

      <section className="sc-statement">
        <p className="sc-watermark" aria-hidden="true">Siempre</p>
        <h2 className="sc-headline">Si hoy lo necesitas,<br />hoy lo tienes.</h2>
        <p>Mil quinientas toneladas de capacidad de frío existen por una sola razón: que tu pedido no dependa de la suerte.</p>
      </section>

      <section className="sc-section sc-paper" id="productos">
        <div className="sc-wrap">
          <div className="sc-products-head">
            <div>
              <p className="sc-mono sc-section-label">Catálogo</p>
              <h2 className="sc-headline">Cinco familias.<br />Doscientas claves.</h2>
            </div>
            <a className="sc-ghost" href={WHATSAPP} target="_blank" rel="noopener noreferrer">¿No ves lo que buscas? Escríbenos →</a>
          </div>
          <div className="sc-pcard-grid">
            {FAMILIES.map((family) => (
              <article className="sc-pcard" key={family.idx}>
                <img className="sc-pcard-photo" src={family.image} alt="" />
                <div className="sc-pcard-multiply" aria-hidden="true" />
                <div className="sc-pcard-inner">
                  <div className="sc-pcard-top">
                    <FamilyIcon type={family.icon} />
                    <span className="sc-pcard-idx">{family.idx}</span>
                  </div>
                  <h3 className="sc-pcard-name">{family.name}</h3>
                  <p className="sc-pcard-desc">{family.desc}</p>
                  <a
                    className="sc-pcard-list"
                    href={familyListUrl(family.name)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver listado de productos
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="sc-band" aria-label="Logística y almacén">
        <img src="/servicarnes/pallets.jpg" alt="Pallets de producto listos para distribución en Grupo Servicarnes" style={{ objectPosition: "center 40%" }} />
        <div className="sc-band-shade" />
        <div className="sc-band-copy">
          <p className="sc-mono">Logística / Almacén</p>
          <strong>200 claves<br />en stock.</strong>
          <div className="sc-rule" />
        </div>
        <p className="sc-mono sc-band-meta">Est. 1996</p>
      </section>

      <section className="sc-section" id="servicio">
        <div className="sc-wrap sc-service-grid">
          <div>
            <h2 className="sc-headline">Un solo contacto.<br />Todo el servicio.</h2>
            <p>
              Atención personal y directa. Tu vendedor gestiona la orden, el reparto y el cobro sin rodeos ni corporativos de por medio. Conoce tu zona y asegura que nunca te quedes sin producto.
            </p>
          </div>
          <div>
            {STEPS.map((step) => (
              <article className="sc-step" key={step.idx}>
                <b>{step.idx}</b>
                <strong>{step.title}</strong>
                <p>{step.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="sc-split" aria-label="Distribución y servicio">
        <PhotoTile
          src="/servicarnes/truck.jpg"
          alt="Unidad refrigerada de distribución Grupo Servicarnes"
          shade="rgba(10, 26, 43, 0.38)"
        >
          <div className="sc-tile-copy">
            <p className="sc-mono">Distribución</p>
            <strong>Flota refrigerada</strong>
          </div>
        </PhotoTile>
        <PhotoTile
          src="/servicarnes/delivery.jpg"
          alt="Repartidor entregando pedido a cliente"
          shade="rgba(0, 78, 134, 0.52)"
          position="center top"
        >
          <div className="sc-tile-copy">
            <p className="sc-mono">Servicio</p>
            <strong>Entrega personalizada</strong>
          </div>
        </PhotoTile>
      </section>

      <section className="sc-section sc-coverage" id="cobertura" ref={coverage.ref}>
        <div className="sc-wrap">
          <p className="sc-mono sc-section-label">Cobertura</p>
          <h2 className="sc-headline">Ocho plazas.<br />Una sola forma de servir.</h2>
          <div className="sc-coverage-grid">
            <div className="sc-map-col">
              <div className="sc-map-frame">
                <iframe
                  key={place.id}
                  title={`Mapa de ${place.name}`}
                  src={mapEmbed(place)}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <a className="sc-map-open" href={mapSearch(place)} target="_blank" rel="noopener noreferrer">
                Abrir {place.name} en Google Maps →
              </a>
            </div>
            <div>
              <ul className="sc-city-list">
                {LOCATIONS.map((loc) => (
                  <li className={place.id === loc.id ? "sc-city is-on" : "sc-city"} key={loc.id}>
                    <button type="button" onClick={() => setPlace(loc)}>
                      <strong>{loc.name}</strong>
                      <span>{loc.address || "Dirección por confirmar"}</span>
                    </button>
                    <a href={`tel:+52${loc.tel}`}>{loc.phone}</a>
                  </li>
                ))}
              </ul>
              <div className="sc-coverage-stats">
                <div>
                  <strong>{coverage.visible ? "80" : "0"}</strong>
                  <em>Rutas</em>
                </div>
                <div>
                  <strong>{coverage.visible ? "170" : "0"}</strong>
                  <em>Unidades de reparto</em>
                </div>
              </div>
              <p className="sc-coverage-note">Cobertura en toda la región de Occidente.</p>
            </div>
          </div>
          <JaliscoReach />
        </div>
      </section>

      <section className="sc-frame-section">
        <div className="sc-frame">
          <h2 className="sc-headline">
            La disponibilidad no se promete. <span>Se almacena.</span>
          </h2>
        </div>
      </section>

      <section className="sc-section" id="nosotros">
        <div className="sc-wrap sc-two">
          <h2 className="sc-headline">Treinta años<br />surtiendo el Occidente.</h2>
          <div>
            <p className="sc-mono sc-red-label">Grupo Servicarnes</p>
            <p>
              Grupo Servicarnes nace de la unión de dos empresas dedicadas a la distribución regional de proteínas cárnicas y alimentos congelados, nacionales y de importación. Matriz en Guadalajara y siete sucursales. Nuestra misión es ofrecer una amplia gama de proteínas y congelados a nuestra comunidad, con un servicio y una atención personalizados.
            </p>
          </div>
        </div>
      </section>

      <section className="sc-section sc-values" ref={values.ref}>
        <div className="sc-wrap">
          <p className="sc-mono">Así trabajamos.</p>
          {["Honestidad", "Servicio", "Trabajo en equipo"].map((word) => (
            <span className={`sc-vword${values.visible ? " is-on" : ""}`} key={word}>{word}</span>
          ))}
        </div>
      </section>

      <section className="sc-split is-flip" aria-label="Calidad y equipo">
        <PhotoTile
          src="/servicarnes/quality.jpg"
          alt="Inspector de calidad en almacén Grupo Servicarnes"
          shade="rgba(10, 26, 43, 0.45)"
          position="center top"
        >
          <p className="sc-mono sc-tile-vert">Control de calidad</p>
        </PhotoTile>
        <PhotoTile
          src="/servicarnes/team.jpg"
          alt="Equipo Grupo Servicarnes en almacén"
          shade="linear-gradient(to top, rgba(10, 26, 43, 0.82) 0%, rgba(10, 26, 43, 0.08) 55%)"
          position="center 30%"
        >
          <div className="sc-tile-copy">
            <p className="sc-mono">Nuestro equipo</p>
            <strong>Personas que<br />conocen tu negocio.</strong>
          </div>
        </PhotoTile>
      </section>

      <section className="sc-segments">
        <h2 className="sc-headline">Tú vendes.<br />Nosotros surtimos.</h2>
        <div className="sc-seg-row">
          <div className="sc-seg-track">
            {[0, 1].map((copy) => (
              <span key={copy}>
                {ROW_MAYOREO.map((word) => (
                  <span className="sc-segword" key={`${copy}-${word}`}>{word} ·</span>
                ))}
              </span>
            ))}
          </div>
        </div>
        <div className="sc-seg-row">
          <div className="sc-seg-track is-rev">
            {[0, 1].map((copy) => (
              <span key={copy}>
                {ROW_MENUDEO.map((word) => (
                  <span className="sc-segword is-outline" key={`${copy}-${word}`}>{word} ·</span>
                ))}
              </span>
            ))}
          </div>
        </div>
        <p className="sc-segments-note">Si tu negocio necesita un abasto constante y frescura garantizada, somos tu mejor opción.</p>
      </section>

      <section className="sc-cta">
        <div className="sc-cta-bg" aria-hidden="true">
          {Array.from({ length: 8 }, (_, index) => (
            <span key={index}>Siempre</span>
          ))}
          {Array.from({ length: 8 }, (_, index) => (
            <span key={`b-${index}`}>Siempre</span>
          ))}
        </div>
        <div className="sc-cta-inner">
          <h2 className="sc-headline">¿Qué necesitas<br />surtir hoy?</h2>
          <p>Mándanos tu lista por WhatsApp y el vendedor de tu zona te contesta. Sin registro, sin cotizadores, sin esperar.</p>
          <a className="sc-btn sc-btn-light" href={WHATSAPP} target="_blank" rel="noopener noreferrer">Escribir por WhatsApp →</a>
        </div>
        <Marquee className="sc-cta-marquee" />
      </section>

      <footer className="sc-footer">
        <div className="sc-wrap sc-footer-grid">
          <div>
            <img className="sc-footer-logo" src="/servicarnes/logo.png" alt="Grupo Servicarnes" />
            <h2>Servicio y variedad.<br />Siempre.</h2>
            <p className="sc-mono">Desde 1996.</p>
            <p className="sc-legal">
              Importadora Servicarnes S.A. de C.V.<br />
              Servicarnes de Vallarta S.A. de C.V.
            </p>
          </div>
          <div>
            <p className="sc-mono">Familias</p>
            <ul>
              {["Res", "Cerdo", "Ave", "Snacks y valor agregado", "Papas"].map((item) => (
                <li key={item}><a href="#productos">{item}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="sc-mono">Sucursales</p>
            <ul>
              {BRANCHES.map(([name]) => <li key={name}>{name}</li>)}
            </ul>
          </div>
          <div>
            <p className="sc-mono">Contacto</p>
            <div className="sc-contact-row"><span>Teléfono</span>[Teléfono]</div>
            <div className="sc-contact-row"><span>WhatsApp</span>[WhatsApp]</div>
            <div className="sc-contact-row"><span>Correo</span>[Correo]</div>
            <div className="sc-contact-row"><span>Horario</span>[Horario]</div>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook →</a>
          </div>
        </div>
        <div className="sc-wrap">
          <p className="sc-copyline">© 2026 Grupo Servicarnes. Todos los derechos reservados.</p>
        </div>
      </footer>

      <a className="sc-float" href={WHATSAPP} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20.5 3.5A11 11 0 0 0 2.1 17.8L1 23l5.4-1.1A11 11 0 0 0 20.5 3.5Zm-8.5 17a9.1 9.1 0 0 1-4.6-1.3l-.3-.2-3.2.7.7-3.1-.2-.3A9.1 9.1 0 1 1 12 20.5Zm5-6.8c-.3-.1-1.6-.8-1.8-.9s-.4-.1-.6.1-.7.9-.8 1-.3.2-.6.1a7.4 7.4 0 0 1-2.2-1.4 8.2 8.2 0 0 1-1.5-1.9c-.2-.3 0-.4.1-.6l.4-.5.2-.3a.5.5 0 0 0 0-.5c0-.1-.6-1.4-.8-1.9s-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.2 5 5 0 0 0 1.1 2.7 11.5 11.5 0 0 0 4.4 4 15 15 0 0 0 1.5.5 3.6 3.6 0 0 0 1.7.1 2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .2-1.2c-.1-.1-.3-.2-.6-.3Z" />
        </svg>
      </a>
    </div>
  );
}

export default function ServicarnesPreview() {
  useEffect(() => {
    document.body.classList.add("sc-body");
    return () => document.body.classList.remove("sc-body");
  }, []);

  return <ServicarnesPage />;
}
